import { useContext, useEffect } from "react";
import GeaoLayout from "../shared/Layout/GeaoLayout";
import { GeaoContext } from "../../GeaoContextProvider";
import { GdkCheckpoint } from "@gdk/checkpoint";
import useTitle from "../../../../hooks/useTitle";
import { useNavigate } from "react-router-dom";
import { GeaoPaths } from "../../constants/GeaoPaths";
import { ClientConfigurationContext } from "../../../../context/ClientConfigurationContextProvider";

export default function ProducerApplicationComplete() {
    useTitle("Application Status");

    const { agentInterview } = useContext(GeaoContext);
    const { gatewayUrl } = useContext(ClientConfigurationContext);
    const navigate = useNavigate();

    useEffect(() => {
        new GdkCheckpoint({
            content: `#overview-checkpoint`,
            data: [
                {
                    title: "Create Profile",
                    status: "completed"
                },
                {
                    title: "Complete Application",
                    status: "completed"
                },
                {
                    title: "Pass Background Check",
                    status: "completed"
                },
                {
                    title: "Start Selling with GEICO",
                    status: "completed"
                }
            ],
            animated: false
        });
    }, []);

    return <GeaoLayout header="Application Status">
        <div className="margin-top margin-bottom container">
            <p className="font--bold" style={{ color: "#616161" }}>Your application is complete.</p>
            <h3>Welcome back, {agentInterview?.questionAnswers?.FirstName?.answer}.</h3>

            <div className="bordered-box w-100 p-1 margin-top">
                <p className="m-2">
                    Congrats! You passed your background check. You’re ready to start selling with GEICO.
                </p>
                <div className="flex-row">
                    <div className="checkpoint p-3 m-2 background overview-block" id="overview-checkpoint" style={{ flexBasis: "375px", flexGrow: 0, flexShrink: 0 }}>
                        <p className="checkpoint checkpoint-heading">What's Next?</p>
                        <ul className="checkpoint-content"></ul>
                    </div>
                    <div className="m-2">
                        <h4 className="margin-top margin-bottom">Here’s how to get started:</h4>
                        <gds-list-wrapper type="bullet-list">
                            <gds-simple-list-item type="bullet-list">
                                Check your email for login information
                            </gds-simple-list-item>
                            <gds-simple-list-item type="bullet-list">
                                Set up multi-factor authentication
                            </gds-simple-list-item>
                            <gds-simple-list-item type="bullet-list">
                                Log in to your account and create a new password
                            </gds-simple-list-item>
                            <gds-simple-list-item type="bullet-list">
                                Explore the online Gateway, find agent resources, and start selling with GEICO
                            </gds-simple-list-item>
                        </gds-list-wrapper>
                    </div>
                </div>
                <div className="flex-row mx-auto margin-top">
                    <button data-onboarding-button-id="ApplicationStatus:ProducerApplicationComplete:ViewCompletedApplication" className="btn btn--secondary" onClick={() => { navigate(GeaoPaths.ProducerApplicationSubmitted) }}>
                        View Completed Application
                    </button>
                    <button data-onboarding-button-id="ApplicationStatus:ProducerApplicationComplete:AgentPortal" className="btn btn--primary" onClick={() => window.location.href = gatewayUrl}>
                        Navigate To Agent Portal
                    </button>
                </div>
            </div>
        </div>
    </GeaoLayout>
}